import React, {useState} from 'react'
import Text from '../../../../components/text/Text'
import WizButton from '../../../../components/button/WizButton'
import {IBanners} from '../../../../apis/banner/getLeaderboardBanner'
import {useImage} from '../../../../utils/image'
import WizImage from '../../../../components/image/WizImage'
import {ReactComponent as IconNext} from '../../assets/images/ic_btn_next.svg'

interface IProps {
    className?: string
    data?: IBanners
}

const LeaderboardBannerItem: React.FC<IProps> = ({className, data}) => {
    const {renderImage} = useImage()

    const [isFocus, setIsFocus] = useState(false)

    return (
        <div
            style={{backgroundColor: data?.background}}
            className={`w-full relative overflow-hidden
             mx-auto mt-[10px] rounded-[5px] h-[320px] sm:h-[270px]`}>
            <div className={'max-w-[1366px] mx-auto block'}>
                <div className={'relative h-full'}>
                    <div className={`hidden sm:block`}>
                        <WizImage
                            src={renderImage(data?.banner_image_mo, 1920)}
                            className={'object-cover w-full h-[270px]'}
                            containerClassName={'w-auto w-full'}
                        />
                    </div>
                    <div className={`sm:hidden`}>
                        <WizImage
                            src={renderImage(data?.banner_image_pc)}
                            containerClassName={'w-auto h-[320px]'}
                            className={'h-full  mx-auto'}
                        />
                    </div>

                    <div className={`flex-1 flex flex-col px-[20px] relative z-[10] pt-[75px] sm:pt-[73px]`}>
                        <div className={'flex-1 flex flex-col justify-center'}>
                            {data?.sub_title?.image_url ? (
                                <div className={`flex flex-col justify-center h-[36px] sm:h-[21px]`}>
                                    <div
                                        className={`h-[26px] bg-[length:auto_26px] sm:h-[21px] sm:bg-[length:auto_21px] w-full bg-no-repeat `}
                                        style={{
                                            backgroundImage: `url(${renderImage(data?.sub_title?.image_url, 720)})`,
                                        }}
                                    />
                                </div>
                            ) : data?.sub_title?.text ? (
                                <Text
                                    inlineStyle={{color: data?.sub_title?.color || '#FFFFFF'}}
                                    className={`text-h2  sm:text-ti2 ${
                                        data?.sub_title?.text?.length >= 26 && 'md:text-[2.3vw] md:leading-[3.5vw] '
                                    }`}>
                                    {data?.sub_title?.text}
                                </Text>
                            ) : (
                                <></>
                            )}
                            {data?.content?.image_pc || data?.content?.image_mo ? (
                                <>
                                    <div className={`h-[154px] sm:h-[120px] w-full`}>
                                        <WizImage
                                            src={renderImage(data?.content?.image_mo, 320)}
                                            alt={`${data?.content?.title} ${data?.content?.desc}`}
                                            containerClassName={'max-h-[120px] max-w-[320px] hidden sm:block'}
                                        />

                                        <WizImage
                                            src={renderImage(data?.content?.image_pc, 480)}
                                            alt={`${data?.content?.title} ${data?.content?.desc}`}
                                            containerClassName={'max-h-[154px] max-w-[480px] sm:hidden'}
                                        />
                                    </div>
                                </>
                            ) : (
                                <Text
                                    inlineStyle={{color: data?.content?.title_color || '#FFFFFF'}}
                                    className={`text-h1 sm:text-h3 antialiased font-sans text-white  break-all ${
                                        data?.content?.title?.length >= 26
                                            ? 'md:text-[3.9vw] md:leading-[5.25vw]'
                                            : 'md:text-[30px] md:leading-[40px] '
                                    } font-bold`}>
                                    {data?.content?.title}
                                </Text>
                            )}
                            {data?.content?.desc && (
                                <Text
                                    inlineStyle={{color: data?.content?.desc_color || '#FFFFFF'}}
                                    className={`text-body1 mt-[10px] sm:text-body3 sm:mt-[5px] break-all`}>
                                    {data?.content?.desc}
                                </Text>
                            )}
                            <div className={'flex items-center'}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LeaderboardBannerItem
